<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="16" height="16" rx="8" fill="#252525" />
    <path
      d="M8.19179 11.25V7.63875C8.19179 7.29828 8.19179 7.12804 8.08602 7.02227C7.98025 6.9165 7.81001 6.9165 7.46954 6.9165"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.01109 4.75H8.01758"
      stroke="white"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
